import { edgePlatformUrl } from '../../../../config/envConfig';

type OptionalSecretLineParams = {
	isPreview: boolean;
	isAvailable: boolean;
	variableName: string;
	value: string;
	notFoundText: string;
};

export const buildEdgeUrlLine = (isProduction: boolean): string[] =>
	isProduction ? [] : [`SITECORE_EDGE_URL=${edgePlatformUrl}`];

export const buildEdgePlatformHostnameLines = (
	isProduction: boolean,
): string[] =>
	isProduction
		? []
		: [
				`SITECORE_EDGE_PLATFORM_HOSTNAME=${edgePlatformUrl}`,
				`NEXT_PUBLIC_SITECORE_EDGE_PLATFORM_HOSTNAME=${edgePlatformUrl}`,
			];

export const pickContextId = (
	isPreview: boolean,
	previewContextId: string,
	liveContextId: string,
): string => (isPreview ? previewContextId : liveContextId);

export const buildOptionalSecretLine = ({
	isPreview,
	isAvailable,
	variableName,
	value,
	notFoundText,
}: OptionalSecretLineParams): string[] => {
	if (!isPreview) return [];
	return [
		isAvailable
			? `${variableName}=${value}`
			: `#${variableName}=${notFoundText}`,
	];
};
